module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/producto.component.html
// module id = ./src/app/productos/producto.component.html
// module chunks = main